// extracted by mini-css-extract-plugin
export default {"border":"qMcU0q","a11yFocus":"NRACF5","a11YFocus":"NRACF5","submitButton":"TiQF5u","title":"sSL3el","subtitle":"MQ2Sbq"};